import React from 'react';
import PropTypes from 'prop-types';
import { CREDIT_CARD_MAP } from 'config/ui';
import { withStyles } from 'theme/withStyles';
import { connect } from 'react-redux';
import classnames from 'classnames';
import iconAmexColored from 'icons/amex-colored.svg';
import iconDiscoverColored from 'icons/discover-colored.svg';
import iconMastercardColored from 'icons/mastercard-colored.svg';
import iconVisaColored from 'icons/visa-colored.svg';
import visuallyHidden from 'styles/visuallyHidden';

const styles = ({ spacing }) => ({
  active: {},
  amex: {
    background: `url(${iconAmexColored}) 0 0 no-repeat`,
  },
  cardType: {
    '&$active': {
      filter: 'saturate(1)',
      opacity: 1,
    },
    filter: 'saturate(0)',
    height: 32,
    marginRight: spacing.unit,
    opacity: 0.5,
    overflow: 'hidden',
    textIndent: -2000,
    transition: 'all 200ms ease',
    width: 47,
  },
  creditCards: {
    display: 'flex',
    margin: [spacing.xs, 0],
    padding: 0,
  },
  disc: {
    background: `url(${iconDiscoverColored}) 0 0 no-repeat`,
  },
  mc: {
    background: `url(${iconMastercardColored}) 0 0 no-repeat`,
  },
  visa: {
    background: `url(${iconVisaColored}) 0 0 no-repeat`,
  },
  visuallyHidden,
});

const getNetworkText = (type) => {
  const locale = {
    [CREDIT_CARD_MAP.amex]: 'American Express',
    [CREDIT_CARD_MAP.disc]: 'Discover',
    [CREDIT_CARD_MAP.mc]: 'Mastercard',
    [CREDIT_CARD_MAP.visa]: 'Visa',
  };

  return locale[type] ? `${locale[type]} is selected.` : '';
};

const LookupCardNetwork = ({ classes, creditCardType, supportedCreditCardTypes }) => (
  <div
    className={classnames('credit-cards', classes.creditCards, {
      amex: creditCardType === CREDIT_CARD_MAP.amex,
      disc: creditCardType === CREDIT_CARD_MAP.disc,
      mc: creditCardType === CREDIT_CARD_MAP.mc,
      visa: creditCardType === CREDIT_CARD_MAP.visa,
    })}
  >
    <p role="status" className={classnames('hidden', classes.visuallyHidden)}>
      {getNetworkText(creditCardType)}
    </p>
    {supportedCreditCardTypes[CREDIT_CARD_MAP.amex] && (
      <div
        className={classnames('amex', classes.cardType, classes.amex, {
          [classes.active]: creditCardType === CREDIT_CARD_MAP.amex,
        })}
      />
    )}
    {supportedCreditCardTypes[CREDIT_CARD_MAP.visa] && (
      <div
        className={classnames('visa', classes.cardType, classes.visa, {
          [classes.active]: creditCardType === CREDIT_CARD_MAP.visa,
        })}
      />
    )}
    {supportedCreditCardTypes[CREDIT_CARD_MAP.mc] && (
      <div
        className={classnames('mc', classes.cardType, classes.mc, {
          [classes.active]: creditCardType === CREDIT_CARD_MAP.mc,
        })}
      />
    )}
    {supportedCreditCardTypes[CREDIT_CARD_MAP.disc] && (
      <div
        className={classnames('disc', classes.cardType, classes.disc, {
          [classes.active]: creditCardType === CREDIT_CARD_MAP.disc,
        })}
      />
    )}
  </div>
);

LookupCardNetwork.propTypes = {
  creditCardType: PropTypes.string,
  supportedCreditCardTypes: {},
};

LookupCardNetwork.defaultProps = {
  creditCardType: '',
  supportedCreditCardTypes: {},
};

const mapStateToProps = ({ data, fields }) => ({
  creditCardType: data.appRequest_linkedPaymentCard_cardNetwork,
  supportedCreditCardTypes: fields.appRequest_linkedPaymentCard_cardNetwork?.lookupValues || {},
});

const StyledLookupCardNetwork = withStyles(styles)(LookupCardNetwork);

export default connect(mapStateToProps)(StyledLookupCardNetwork);
